import React from "react"

import { getFormattedMessage } from "../../components/shared_components_registration"

export const LoadingSpinner = ({ sm = false }) => {
  const loadingStr = getFormattedMessage("general.loading", "Loading")
  return (
    <div align={"center"} style={{ display: "flex", alignItems: "center" }}>
      <div
        className={`spinner-border ${sm ? "spinner-border-sm " : ""}text-primary text-center`}
        role={"status"}
      />
      &nbsp;&nbsp;
      {sm ? <span>{loadingStr}...</span> : <h5 style={{ marginTop: "0.5rem" }}>{loadingStr}...</h5>}
    </div>
  )
}

export default function PageLoadingPanel({ height = 400, fullHeight = false }) {
  return (
    <div
      className={"center_middle dashed-black-border"}
      style={{ height: fullHeight ? "100%" : `${height}px` }}
    >
      <LoadingSpinner />
    </div>
  )
}
